import React, { useState } from 'react';
import {
  Calendar,
} from 'react-big-calendar';
import {
  DateTime,
} from 'luxon';

import {
  ActivityModal,
  WorkoutResult,
} from 'web-components';

import Toolbar from './Toolbar';
import LuxonLocalizer from './luxonLocalizer';

import * as S from './styled';

interface EventProps {
  event: {
    color: string;
    isLog: boolean;
    startTime: string;
    person_name: string;
  }
}

interface Props {
  events: Array<any>,
  onNavigate: { (day: Date): void },
  onNewWorkoutClick: { ({ start }: { start: Date }): void }
}

const getComponents = ({
  clients,
  calendarSelectedUser,
  onFilter,
  onNewWorkoutClick,
}: any) => ({
  toolbar: (props: any) => (
    <Toolbar
      {...props}
      onNewWorkoutClick={() => onNewWorkoutClick({ start: new Date() })}
      clients={clients}
      onFilter={onFilter}
      calendarSelectedUser={calendarSelectedUser}
    />
  ),
  event: ({ event }: EventProps) => (
    <S.Event color={event.color}>
      {event.startTime}
      {' '}
      {event.person_name}
    </S.Event>
  ),
});

const CalendarContainer = (props: Props) => {
  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const {
    events,
    onNavigate,
    onNewWorkoutClick,
  } = props;

  return (
    <S.CalendarContainer>
      <Calendar
        style={{
          width: '100%',
        }}
        views={['month']}
        popup
        events={events}
        selectable
        endAccessor="end"
        startAccessor="start"
        localizer={LuxonLocalizer(DateTime, { firstDayOfWeek: 0 })}
        components={getComponents(props)}
        onSelectEvent={(event) => {
          if (event.isLog) setSelectedLog(event);
          if (!event.isLog) setSelectedEvent(event);
        }}
        onNavigate={onNavigate}
        onSelectSlot={onNewWorkoutClick}
      />
      <ActivityModal
        id={selectedLog?.id}
        onRequestClose={() => setSelectedLog(null)}
      />
      <WorkoutResult
        id={selectedEvent?.id}
        onRequestClose={() => setSelectedEvent(null)}
      />
    </S.CalendarContainer>
  );
};

export default CalendarContainer;
